import { supabase } from './supabase';

const PAGE_SIZE = 1000;

/**
 * Fetches every row from a Supabase query by paginating through all pages.
 * Pass a factory function that returns the base query (without range/limit)
 * and this will keep fetching until all rows are returned.
 */
export async function fetchAllRows<T>(
  buildQuery: () => ReturnType<typeof supabase.from>
): Promise<T[]> {
  const results: T[] = [];
  let from = 0;

  while (true) {
    const { data, error } = await (buildQuery() as any).range(from, from + PAGE_SIZE - 1);

    if (error) throw error;
    if (!data || data.length === 0) break;

    results.push(...(data as T[]));

    if (data.length < PAGE_SIZE) break;
    from += PAGE_SIZE;
  }

  return results;
}
